import { render, staticRenderFns } from "./FarmDashboard.vue?vue&type=template&id=21c3f822&"
import script from "./FarmDashboard.vue?vue&type=script&lang=js&"
export * from "./FarmDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports